import axios from 'axios';
import React, { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import { ExternalTokenService } from '@cbbt/itf-idv-journey';
import { createRestClient } from '@cbbt/lib-client-rest';
import { safeParse } from '../helper/safeParse.js';
import { defaultIdentityState, } from '../types/identityContextTypes.js';
export const IdvContext = createContext({});
export const IdvContextProvider = ({ children, idvVariables, }) => {
    const docUploadLabClient = useMemo(() => {
        const client = axios.create({
            baseURL: idvVariables.apis.docUploadLabUrl,
            headers: {},
        });
        return client;
    }, [idvVariables.apis.docUploadLabUrl]);
    const idvUploadLabClient = useMemo(() => {
        const client = axios.create({
            baseURL: idvVariables.apis.idvUploadLabUrl,
            headers: {
                'x-lbg-channel': idvVariables.iaLabHeaders.channel,
                'x-lbg-journey': idvVariables.iaLabHeaders.journey,
                'x-lbg-product': idvVariables.iaLabHeaders.product,
                'x-lbg-brand': idvVariables.state.brand,
            },
        });
        return client;
    }, [
        idvVariables.apis.idvUploadLabUrl,
        idvVariables.iaLabHeaders,
        idvVariables.state.brand,
    ]);
    const svcIdvClient = useMemo(() => createRestClient(ExternalTokenService, {
        baseURL: idvVariables.apis.svcIdvBasePath,
        headers: {
            'Ocp-Apim-Subscription-Key': idvVariables.apimSubscriptionKey,
        },
    }), [idvVariables.apimSubscriptionKey, idvVariables.apis.svcIdvBasePath]);
    const defaultDocType = sessionStorage.getItem('docType');
    const defaultCapturePhotoResponse = sessionStorage.getItem('capturePhotoResponse');
    const defaultCaptureResponse = sessionStorage.getItem('captureSelfieResponse');
    const [idvState, setIdvState] = useState({
        applicationProps: idvVariables.state,
        docUploadLabClient,
        idvUploadLabClient,
        svcIdvClient,
        idvStateHandler: idvVariables.callbackMethods.idvStateHandler,
        mitekLicenseKey: idvVariables.mitekLicenseKey,
        labels: idvVariables.labels,
        getJwt: idvVariables.callbackMethods.getJwt,
        assetsPath: idvVariables.assetsPath,
        identityState: defaultIdentityState,
        docType: safeParse(defaultDocType),
        capturePhotoResponse: safeParse(defaultCapturePhotoResponse),
        captureSelfieResponse: safeParse(defaultCaptureResponse),
        identityConfirmationByPost: idvVariables.identityConfirmationByPost || false,
    });
    const value = useMemo(() => ({ idvState, setIdvState }), [idvState]);
    useEffect(() => {
        sessionStorage.setItem('docType', JSON.stringify(idvState.docType));
    }, [idvState.docType]);
    useEffect(() => {
        sessionStorage.setItem('capturePhotoResponse', JSON.stringify(idvState.capturePhotoResponse));
    }, [idvState.capturePhotoResponse]);
    useEffect(() => {
        sessionStorage.setItem('captureSelfieResponse', JSON.stringify(idvState.captureSelfieResponse));
    }, [idvState.captureSelfieResponse]);
    useEffect(() => {
        sessionStorage.setItem('idvSaveData', JSON.stringify(idvState.identityState.idvSaveData));
    }, [idvState.identityState.idvSaveData]);
    return React.createElement(IdvContext.Provider, { value: value }, children);
};
export const useIdvProvider = () => {
    const idvContext = useContext(IdvContext);
    if (!idvContext) {
        throw new Error('idv config must be used within a provider');
    }
    return idvContext;
};
//# sourceMappingURL=index.js.map